import React from 'react'
import {Button, Modal} from 'react-bootstrap'

const AlertMessageBox = ({show, handleClose, message}: any) => {
  return (
    <>
      <Modal backdrop='static' show={show} onHide={handleClose}>
        <div className='modal-header text-center row'>
          <div className='icon-box col-12'>
            <i className={`fa fa-exclamation-circle fa-5x `}></i>
          </div>
        </div>
        <div className='modal-body row justify-content-center'>
          <h1 className='text-danger text-center'>{message}</h1>
        </div>
        <div className='modal-footer'>
          <Button onClick={handleClose}>Okay</Button>
        </div>
      </Modal>
    </>
  )
}

export default AlertMessageBox
